/**
 * ArticleLanguageSwitch — End-of-article button to read the post in the other
 * language. Switching the language triggers BlogPostPage's redirect logic,
 * which navigates to the equivalent post via its `translationSlug`. A plain
 * link can't do this: it would land on the other-language slug while the active
 * language is unchanged and get bounced straight back. Setting the language is
 * what makes the switch stick.
 */

import { motion } from 'framer-motion';
import { useT } from '../../i18n';

export function ArticleLanguageSwitch({ targetLang }: { targetLang: 'no' | 'en' }) {
  const { setLang } = useT();
  const label =
    targetLang === 'no' ? 'Les denne artikkelen på norsk' : 'Read this article in English';
  const flag = targetLang === 'no' ? '🇳🇴' : '🇬🇧';

  return (
    <div className="max-w-3xl mx-auto mt-12 flex justify-center">
      <motion.button
        whileTap={{ scale: 0.96 }}
        onClick={() => setLang(targetLang)}
        aria-label={label}
        className="inline-flex items-center gap-2 rounded-full border border-teal/30 bg-teal/5 px-5 py-2.5 font-display text-sm font-medium text-teal-dark hover:bg-teal/10 hover:border-teal transition-colors"
      >
        <span className="text-base" aria-hidden="true">{flag}</span>
        {label}
        <span aria-hidden="true">→</span>
      </motion.button>
    </div>
  );
}
